import {
  DashboardFilterType,
  DashboardFilterValue,
  DataRange,
} from '@/client/reports';
import { AppButton, AppDropdownButton } from '@/ui/buttons';
import { FlexContainer } from '@/ui/styled-ui';
import { BarIcon, dataRangeOptions } from '@/utils/helpers';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FilterSelector } from './FilterSelector';

type AnalyticsHeaderProps = {
  dataRange: DataRange;
  setDataRange: React.Dispatch<React.SetStateAction<DataRange>>;
  filterData: DashboardFilterValue;
  setFilterData: React.Dispatch<React.SetStateAction<DashboardFilterValue>>;
};

export const AnalyticsHeader = ({
  dataRange,
  setDataRange,
  filterData,
  setFilterData,
}: AnalyticsHeaderProps) => {
  const { t } = useTranslation();
  const options = dataRangeOptions(t);
  const [showFilter, setShowFilter] = useState(false);

  const rangeItems = [
    {
      label: options[0].label,

      command: () => {
        setDataRange(options[0]);
      },
    },
    {
      label: options[1].label,
      command: () => {
        setDataRange(options[1]);
      },
    },
  ];

  const filterLabel = {
    all_data: t('phishing.analytics.filterData.all_data'),
    managers: t('phishing.analytics.filterData.managers', {
      count: filterData.managers?.length ?? 0,
    }),
    departments: t('phishing.analytics.filterData.departments', {
      count: filterData.departments?.length ?? 0,
    }),
    branches: t('phishing.analytics.filterData.branches', {
      count: filterData.branches?.length ?? 0,
    }),
    groups: t('phishing.analytics.filterData.groups', {
      count: filterData.groups?.length ?? 0,
    }),
  };

  return (
    <FlexContainer
      gap={16}
      justify="flex-start"
      className="mb-4"
      id="analytics-header"
    >
      <AppDropdownButton
        menuId={'data-range-menu'}
        items={rangeItems}
        label={t('phishing.analytics.dataRange', {
          range: dataRange.label,
        })}
        type="outlined"
        severity="secondary"
        icon="pi pi-calendar"
        iconPos="left"
      />
      <AppButton
        label={t('phishing.analytics.filterData.prefix', {
          data: filterLabel[filterData?.type || DashboardFilterType.ALL_DATA],
        })}
        type="outlined"
        severity="secondary"
        icon={<BarIcon />}
        iconPos="left"
        onClick={() => setShowFilter(!showFilter)}
      />

      {showFilter && (
        <FilterSelector
          key={`filter-${JSON.stringify(filterData)}`}
          onSubmit={(data) => {
            setFilterData(data);
            setShowFilter(false);
          }}
          initialFilter={filterData}
          onHide={() => setShowFilter(false)}
          visible={showFilter}
        />
      )}
    </FlexContainer>
  );
};
